import React, { useEffect, useRef, useState } from "react";
import clsx from "clsx";
import { assets } from "../../../assets/assets";

interface PhoneFrameVideoProps {
    videoSrc: string;
    poster: string;
    className?: string;
}

export default function PhoneFrameVideo({ videoSrc, className, poster }: PhoneFrameVideoProps) {
    const containerRef = useRef<HTMLDivElement | null>(null);
    const videoRef = useRef<HTMLVideoElement | null>(null);

    useEffect(() => {
        videoRef.current?.play();
    }, []);

    return (
        <div ref={containerRef} className={clsx("relative aspect-[9/19.5] w-full", className)}>
            {/* Video */}
            <div className="absolute inset-[2%] overflow-hidden rounded-[1.5rem] bg-black">
                <video
                    ref={videoRef}
                    src={videoSrc}
                    poster={poster}
                    muted
                    loop
                    playsInline
                    preload="metadata"
                    className="h-full w-full object-cover"
                />
            </div>

            {/* Frame */}
            <img
                src={assets.iphone_frame}
                alt="iPhone frame"
                className="pointer-events-none absolute inset-0 h-full w-full"
            />
        </div>
    );
}
